<template>
  <div class="section flex_child_3_3 md_content_2">
      <div class="section_wrap row" >
        <h6 class="--blue70 mb20 section_title">
          {{ $t('rehabilitation.record') }}
        </h6>
        <LoadingOverlay
            :activeSyncProps="activeSyncProps"
            :isFullPageProps="false"
        />
        <div
            ref="recordBox"
            class="reh_con_scroll rehab_record_list"
        >
            <ListTable
                :headerItems="headerItems"
                :itemRows="showRehabilitationRecord"
            />
            <div
                v-if=" activeSyncProps && this.selectedExerciseRecordListProps.length === 0"
                class="mt125 out_box"
                style="font-size: 60px; color: var(--grey20);"
            />
          </div>
      </div>
      <span
          class="md_close pointer"
          @click="modalClose"
      >
          <img
              src="/images/union.svg"
              alt=""
          />
      </span>
  </div>
</template>
<script>
import ListTable from "../../../Table/listTable/index";
import LoadingOverlay from '@/components/loadingOverlay';

export default {
  props: ['selectedExerciseRecordListProps', 'activeSyncProps', 'selectedExerciseProps'],
  components: {
    ListTable,
    LoadingOverlay,
  },
  data() {
    return {
      headerItems: [
        {
          index: 0,
          keyTitle: this.$t('rehabilitation.start_time'),
          keyType: 'HeaderDefault',
          class: [''],
          parentClass: [],
          componentOptions: {},
          keyRange: [],
          values: ''
        },
        {
          index: 1,
          keyTitle: this.$t('rehabilitation.execution_time'),
          keyType: 'HeaderDefault',
          class: [],
          parentClass: [],
          componentOptions: {},
          keyRange: [],
          values: '',
        },
        {
          index: 2,
          keyTitle: this.$t('exercise.record.minAngle'),
          keyType: 'HeaderDefault',
          class: [],
          parentClass: [],
          componentOptions: {},
          keyRange: [],
          values: '',
        },
        {
          index: 3,
          keyTitle: this.$t('exercise.record.maxAngle'),
          keyType: 'HeaderDefault',
          class: [],
          parentClass: [],
          componentOptions: {},
          keyRange: [],
          values: '',
        },
        {
          index: 4,
          keyTitle: this.$t('exercise.record.reView'),
          keyType: 'HeaderDefault',
          class: [],
          parentClass: [],
          componentOptions: {},
          keyRange: [],
          values: '',
          style: {
            flexGrow: '6 !important',
          }
        },
      ],
    }
  },
  methods: {
    modalClose: function (event) {
      this.$modal.hide('details-and-record-modal');
      event?.stopPropagation();
      event?.preventDefault();
    },
  },
  computed: {
    showRehabilitationRecord() {
      const itemRows = [];

      const device = this.selectedExerciseProps.seqDeviceType;
      const position = this.selectedExerciseProps.exerciseGuide?.exerciseGuidePosition;

      for (let i = 0; this.selectedExerciseRecordListProps.length > i; i++) {
        let values = {
          min: '',
          max: '',
        }

        if (device === 1) {
          values.min = Math.floor(this.selectedExerciseRecordListProps[i].iuppiterUsage?.iuppiterUsageMinAngle);
          values.max = Math.floor(this.selectedExerciseRecordListProps[i].iuppiterUsage?.iuppiterUsageMaxAngle);
        } else {
          if (position === 3) {
            values.min = Math.floor(this.selectedExerciseRecordListProps[i].iuppiterProUsage?.usageKneeMinAngle);
            values.max = Math.floor(this.selectedExerciseRecordListProps[i].iuppiterProUsage?.usageKneeMaxAngle);
          } else {
            values.min = Math.floor(this.selectedExerciseRecordListProps[i].iuppiterProUsage?.usageAnkleMinAngle);
            values.max = Math.floor(this.selectedExerciseRecordListProps[i].iuppiterProUsage?.usageAnkleMaxAngle);
          }
        }

        const items = [];
        items.clickEvent = {
          func: '',
          params: '',
          key: 'none'
        }
        items.push({
          index: 0,
          keyTitle: '',
          keyType: 'Default',
          class: [],
          parentClass: [],
          componentOptions: {},
          keyRange: [],
          values: this.moment(this.selectedExerciseRecordListProps[i]?.deviceUsage?.usageStartDatetime).locale(this.$t('country')).format('lll'),
        });
        items.push({
          index: 1,
          keyTitle: '',
          keyType: 'Default',
          class: [],
          parentClass: [],
          componentOptions: {},
          keyRange: [],
          values: this.moment.utc(this.moment.duration(this.selectedExerciseRecordListProps[i]?.deviceUsage?.deviceUsageDuration, 'second').asMilliseconds()).format('HH:mm:ss')
        });
        items.push({
          index: 2,
          keyTitle: '',
          keyType: 'Default',
          class: [],
          parentClass: [],
          componentOptions: {},
          keyRange: [],
          values: values.min + '˚',
        });
        items.push({
          index: 3,
          keyTitle: '',
          keyType: 'Default',
          class: [],
          parentClass: [],
          componentOptions: {},
          keyRange: [],
          values: values.max + '˚',
        });
        items.push({
          index: 4,
          keyTitle: '',
          keyType: 'Default',
          class: [],
          parentClass: [],
          componentOptions: {},
          keyRange: [],
          values: this.selectedExerciseRecordListProps[i]?.exerciseCourse?.exerciseFeedback,
          style: {
            flexGrow: '6 !important',
          }
        });
        itemRows.push(items);
      }
      return itemRows;
    }
  },
}
</script>
<style lang="scss">
.flex_child_3_3 {
  -webkit-box-flex: 3;
  -ms-flex: 3 3 10rem;
  flex: 3 3 10rem;
  overflow: hidden;
}

.mt125 {
  margin-top: 125px;
}

.rehab_record_list {
  .table-container {
    .table-header {
      position: sticky;
      top: 0;
      background: var(--grey10);
    }

    .table-header:hover {
      background: var(--grey10);
    }

    .item-parent {
      margin: 0 !important;
    }

    .table-body {
      .item-value {
        font-size: 12px;
      }
    }
  }
}

.remote_monitor_spinner_container {
  position: absolute;
  top: 54%;
  left: 0;
  width: 100%;
}
</style>